
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PersonalInfoSectionProps {
  firstName: string;
  lastName: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PersonalInfoSection = ({ firstName, lastName, onChange }: PersonalInfoSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="firstName">First Name *</Label>
        <Input 
          id="firstName" 
          name="firstName" 
          value={firstName} 
          onChange={onChange} 
          required 
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="lastName">Last Name *</Label>
        <Input 
          id="lastName" 
          name="lastName" 
          value={lastName} 
          onChange={onChange} 
          required 
        />
      </div>
    </div>
  );
};

export default PersonalInfoSection;
